import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="w-full mx-auto bg-pink-600 fixed top-0 z-10 shadow">
      <nav className="lg:w-3/4 lg:mx-auto mx-4 text-white flex justify-between items-center py-2">
        <div className="flex justify-start items-center w-full">
          <Link
            to="/"
            className="text-4xl font-semibold italic font-display flex items-center"
          >
            MusicMant
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-700 mt-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
              />
            </svg>
            {/* <img
                src="/images/logo2.png"
                className="w-6 h-6 inline-block"
                alt="r"
              /> */}
            a
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
